import React from "react"

import { Box } from "@mui/material"

import {
	PageHeader,
	PageSectionTitle,
	RoutesData,
} from "components/commons"
import {
	CompatibleAssetsTable,
} from "components/proposals"
import {
	AssetMatchBrand,
	OrderType,
	PaginatedResponse,
	SearchPriorityMatch,
} from "models"
import { MatchService } from "services/match.service"
import {
	ErrorResponse,
	RestResponse,
} from "@sinossi/mates-react-library"
import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"
import withUseRouter, { UseRouterParams } from "services/router"
import {AccountServices} from "../../services/account.services";

interface ProposalsProps extends UseRouterParams
{
}
interface ProposalsState extends MatesComponentState
{
	loading: boolean
	compatibleAssets: PaginatedResponse<AssetMatchBrand> | null
	compatibleAssetsFilter: SearchPriorityMatch
	likes: string[]
}
class Proposals extends React.Component<ProposalsProps, ProposalsState>
{
	private readonly matesComponent: MatesComponent<ProposalsProps, ProposalsState> = new MatesComponent(this)
	private defaultCompatibleFilter: SearchPriorityMatch =  {
		pageSize: 10,
		pageId: 0,
		orderType: null,
		orderBy: null,
		priorityId: null,
	}

	constructor(props: ProposalsProps)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			compatibleAssets: null,
			compatibleAssetsFilter: this.defaultCompatibleFilter,
			loading: true,
			likes: []
		}
	}

	public componentDidMount()
	{
		//this.getCompatibleAssets()
	}

	

	private getCompatibleAssets = (): void => {
		MatchService.getMatchesByCompanyId(this.state.compatibleAssetsFilter, this.getMatchCallback, this.matesComponent.onException)
	}

	private getMatchCallback = (response: RestResponse<PaginatedResponse<AssetMatchBrand>, ErrorResponse>): void => {
		if(response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			compatibleAssets: response.data,
		}), () => AccountServices.getAssetLikes(this.getLikesCallback, this.matesComponent.onError))
	}

	private getLikesCallback = (response: RestResponse<any, ErrorResponse>) => {
		if(response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			loading: false,
			likes: response.data ?? []
		}))
	}

	private onCompatibleAssetsPaginationChanged = (pageId: number, pageSize: number): void => {
		this.setState(
			() => ({
				compatibleAssetsFilter: {
					...this.state.compatibleAssetsFilter,
					pageId: pageId,
					pageSize: pageSize,
				},
			}),
			this.getCompatibleAssets
		)
	}

	private onCompatibleAssetsSortChanged = (orderBy: string|null, orderType: OrderType|null) => {
		this.setState(
			() => ({
				compatibleAssetsFilter: {
					...this.state.compatibleAssetsFilter,
					orderBy: orderBy,
					orderType: orderType,
				},
			}),
			this.getCompatibleAssets
		)
	}

	private getLikes = () =>{
		AccountServices.getAssetLikes(this.getAssetLikesCallback, this.matesComponent.onError)
	}

	private getAssetLikesCallback = (response: any) => {
		if(response.hasError()) {
			this.matesComponent.onError(response)
			return
		}

		this.setState(() => ({
			likes: response.data,
			loading: false
		}))
	}

	render()
	{
		return (
			<Box sx={{ width: '100%', pt: 2, position: "relative" }}>
				<PageHeader
					title={RoutesData.PROPOSALS.title}
					paths={[ RoutesData.DASHBOARD, RoutesData.PROPOSALS ]}
				/>

				{/*<ProposalsAdvancedSearch />*/}

				<Box sx={{ mt: 3, backgroundColor: "white"}}>
					<PageSectionTitle title={RoutesData.PROPOSALS.title} />
					<Box mt={2}></Box>
					<CompatibleAssetsTable
					/>
				</Box>
			</Box>
		)
	}
}

export default withUseRouter(Proposals)
